import React from "react";
import { getErrorMessage } from "../../utils/errorUtils";
import { getSupportEmail } from "../../utils/domainConfig";

interface TurnstileErrorMessageProps {
  error: unknown;
}

/**
 * Renders error message with optional "Dowiedz się więcej" link for Turnstile errors.
 * Used across grants pages (calls list, archive, call details).
 *
 * For Turnstile errors we always surface a "contact support" line with a mailto
 * link: the inline page error is the surface most users actually read (the top
 * verification banner flickers/clears on each widget retry and is easy to miss),
 * so it must carry a clear, actionable next step when refreshing / switching
 * browser does not help.
 */
export const TurnstileErrorMessage: React.FC<TurnstileErrorMessageProps> = ({
  error,
}) => {
  const err = getErrorMessage(error);
  const supportEmail = getSupportEmail();

  return (
    <>
      <p className="text-sm mt-1">{err.message}</p>
      {err.isTurnstileError && (
        <p className="text-sm mt-2">
          {err.docsUrl && (
            <>
              <a
                href={err.docsUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="underline font-medium"
              >
                Dowiedz się więcej
              </a>
              {" · "}
            </>
          )}
          Jeśli problem nie ustąpi, napisz do pomocy technicznej:{" "}
          <a
            href={`mailto:${supportEmail}`}
            className="underline font-medium"
          >
            {supportEmail}
          </a>
        </p>
      )}
    </>
  );
};
